import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { SECTORS, SECTOR_KEYS, CONTENT_TYPES, CONTENT_STATUS } from "../lib/sectors";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "./ui/dialog";

const today = () => new Date().toISOString().slice(0, 10);
const empty = (sector) => ({ sector: sector || "wellness", title: "", body: "", type: "post", date: today(), status: "idea" });

export function ContentModal({ open, onClose, onSaved, editing, defaultSector, lockSector, allowedSectors }) {
  const sectors = allowedSectors && allowedSectors.length ? allowedSectors : SECTOR_KEYS;
  const [form, setForm] = useState(empty(defaultSector || sectors[0]));

  useEffect(() => {
    if (open) setForm(editing ? { ...editing } : empty(defaultSector || sectors[0]));
  }, [open, editing, defaultSector]);

  const save = async () => {
    if (!form.title.trim()) { toast.error("Inserisci un titolo"); return; }
    const payload = {
      sector: form.sector, title: form.title, body: form.body || "",
      type: form.type, date: form.date, status: form.status,
    };
    if (editing) { await api.put(`/contents/${editing.id}`, payload); toast.success("Contenuto aggiornato"); }
    else { await api.post("/contents", payload); toast.success("Contenuto salvato"); }
    onClose();
    onSaved && onSaved();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass border-white/10 max-w-lg" data-testid="content-modal">
        <DialogHeader>
          <DialogTitle className="font-display">{editing ? "Modifica contenuto" : "Nuovo contenuto"}</DialogTitle>
          <DialogDescription className="text-slate-400">Pianifica un contenuto per uno dei tuoi settori.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-1">
          {!lockSector && sectors.length > 1 && (
            <div className="flex flex-wrap gap-2">
              {sectors.map((k) => {
                const S = SECTORS[k]; const Icon = S.icon; const on = form.sector === k;
                return (
                  <button key={k} data-testid={`content-sector-${k}`} onClick={() => setForm({ ...form, sector: k })}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border transition-colors"
                    style={on ? { background: S.soft, color: S.hex, borderColor: S.border } : { color: "#94a3b8", borderColor: "rgba(255,255,255,0.08)" }}>
                    <Icon className="h-3.5 w-3.5" /> {S.short}
                  </button>
                );
              })}
            </div>
          )}
          <input data-testid="content-title-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
            placeholder="Titolo del contenuto" className="w-full bg-white/5 border border-white/10 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none" />
          <textarea data-testid="content-body-input" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })}
            placeholder="Testo / caption / note…" rows={4}
            className="w-full bg-white/5 border border-white/10 rounded-xl px-3.5 py-2.5 text-sm focus:outline-none resize-none" />
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="text-xs text-slate-400">Formato</label>
              <select data-testid="content-type-select" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}
                className="w-full mt-1 bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-sm focus:outline-none capitalize">
                {CONTENT_TYPES.map((t) => <option key={t} value={t} className="bg-slate-900">{t}</option>)}
              </select>
            </div>
            <div>
              <label className="text-xs text-slate-400">Stato</label>
              <select data-testid="content-status-select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}
                className="w-full mt-1 bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-sm focus:outline-none capitalize">
                {CONTENT_STATUS.map((t) => <option key={t} value={t} className="bg-slate-900">{t}</option>)}
              </select>
            </div>
            <div>
              <label className="text-xs text-slate-400">Data</label>
              <input data-testid="content-date-input" type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })}
                className="w-full mt-1 bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-sm focus:outline-none" />
            </div>
          </div>
        </div>
        <DialogFooter>
          <button onClick={onClose} className="px-4 py-2.5 rounded-xl bg-white/5 border border-white/10 text-sm hover:bg-white/10 transition-colors">Annulla</button>
          <button data-testid="save-content-button" onClick={save} className="px-4 py-2.5 rounded-xl bg-indigo-500 text-white text-sm font-semibold hover:bg-indigo-400 transition-colors">Salva</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
